import { IFlowOptions, ITokenData } from 'types';
import { OptionsActions, TYPES } from './actions';

interface OptionsReducerState {
  isLoading: boolean;
  error?: string;

  hasLoadedOptions: boolean;
  options?: IFlowOptions;

  tokenData?: ITokenData;
}

const initialState: OptionsReducerState = {
  isLoading: true,
  error: '',
  hasLoadedOptions: false,
};

export const optionsReducer = (state = initialState, action: OptionsActions) => {
  switch (action.type) {
    case TYPES.GET_OPTIONS:
      return {
        ...state,
        isLoading: true,
      };

    case TYPES.GET_OPTIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasLoadedOptions: true,
        options: {
          ...action.payload.options,
        },
      };

    case TYPES.GET_OPTIONS_FAILURE:
      return {
        ...state,
        isLoading: false,
        hasLoadedOptions: false,
        error: action.payload.error,
      };

    case TYPES.STORE_TOKEN:
      return {
        ...state,
        tokenData: action.payload.tokenData,
      };

    default:
      return state;
  }
};
